const traceLevels = {
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
};

module.exports.traceLevels = traceLevels;
